export const DELETE_SUCCESS = 'Модель удалена';
export const DELETE_ERROR = 'Не удалось удалить модель';
